import { useEffect, useState } from "react";
import { navLinks } from "@/mocks/homeContent";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const solid = scrolled || open;

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-300 ${
        solid
          ? "bg-background-50/95 backdrop-blur border-b border-background-200"
          : "bg-transparent"
      }`}
    >
      <div className="w-full px-4 md:px-8 h-[68px] flex items-center justify-between">
        <a href="#top" className="flex items-center gap-2 shrink-0">
          <span
            className={`w-9 h-9 rounded-lg flex items-center justify-center text-lg ${
              solid ? "bg-primary-500 text-background-50" : "bg-background-50 text-primary-600"
            }`}
          >
            <i className="ri-movie-2-line" aria-hidden="true"></i>
          </span>
          <span
            className={`font-heading text-lg font-bold tracking-tight ${
              solid ? "text-foreground-950" : "text-background-50"
            }`}
          >
            榴莲视频
          </span>
        </a>

        <nav className="hidden lg:flex items-center gap-1">
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              className={`px-3 py-2 text-sm rounded-md transition-colors ${
                solid
                  ? "text-foreground-700 hover:text-primary-700 hover:bg-primary-100"
                  : "text-background-100 hover:text-background-50 hover:bg-background-50/10"
              }`}
            >
              {link.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <a
            href="#install"
            className="hidden sm:inline-flex items-center gap-1.5 bg-primary-500 hover:bg-primary-600 text-background-50 text-sm font-medium px-4 py-2 rounded-md transition-colors whitespace-nowrap"
          >
            <i className="ri-download-2-line" aria-hidden="true"></i>
            开始下载
          </a>
          <button
            type="button"
            onClick={() => setOpen((v) => !v)}
            aria-label="打开导航菜单"
            aria-expanded={open}
            className={`lg:hidden w-10 h-10 flex items-center justify-center rounded-md text-xl transition-colors ${
              solid ? "text-foreground-900 hover:bg-background-100" : "text-background-50 hover:bg-background-50/10"
            }`}
          >
            <i className={open ? "ri-close-line" : "ri-menu-line"} aria-hidden="true"></i>
          </button>
        </div>
      </div>

      {open ? (
        <div className="lg:hidden bg-background-50 border-b border-background-200 px-4 pb-4">
          <nav className="flex flex-col">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={() => setOpen(false)}
                className="px-3 py-3 text-sm text-foreground-700 border-b border-background-100 last:border-0 hover:text-primary-700"
              >
                {link.label}
              </a>
            ))}
          </nav>
        </div>
      ) : null}
    </header>
  );
}